import * as React from 'react'
import { Link } from 'react-router-dom'
import UIMessages from '../../utils/ui-messages'
import history from 'src/history'
import { Button } from '@mobiscroll/react-latest'

interface IProps {
  cancelPath: string
  isSaving: boolean
  onSave?: (e: React.SyntheticEvent) => void
  disabled?: boolean
}

const EditDriverBottomBar = ({ cancelPath, isSaving, onSave, disabled = false }: IProps) => {
  const saveButtonText = isSaving ? UIMessages.common.saving : UIMessages.common.save
  const handleRedirect = (path: string) => {
    history.push(path)
  }
  return (
    <div className='flex absolute bottom-0 flex items-center justify-end bg-light-grey7 px2 py1 w100 z1'>
      <div className='mr3'>
        <Button
          ariaLabel={`Cancel and redirect to ${cancelPath}`}
          className='mbsc-flat-white-btn'
          onClick={() => handleRedirect(cancelPath)}
        >
          {UIMessages.common.cancel}
        </Button>
        {!onSave && (
          <Button ariaLabel='Submit changes' className='mbsc-success-btn' type='submit'>
            {saveButtonText}
          </Button>
        )}
        {onSave && !disabled && (
          <Button ariaLabel='Save changes' className='mbsc-success-btn' onClick={onSave}>
            {saveButtonText}
          </Button>
        )}
      </div>
    </div>
  )
}

export default EditDriverBottomBar



// WEBPACK FOOTER //
// ./src/components/drivers/EditDriverBottomBar.tsx